import React, { useState, useEffect, useContext } from 'react';
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import { QaDetailContextProvider, useQaDetailContext } from './QaDetailContext';
import queryString from 'query-string';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Button from '@material-ui/core/Button';
import { AppContext } from '../../../AppContext';
import { QaDetailContext } from './QaDetailContext';
import roles from '../../../helpers/roles';

// SERVICES
// import { getOrderById } from '../../services';

// TABS
import { TabBar } from '../../TabBar';
import { QaDetailProfileTab, QaDetailRestrictionsTab } from './qaDetailTabs';
import { getQaUserById, getQaUserPermissions } from '../../../services';
import { getQaUserPermissionsById } from '../../../services/userPermissions.service';
import { set } from 'lodash';

const { ADMIN, QA, UNDERWRITER, UNDERWRITER_READONLY, FIELD_REP } = roles;
const styles = theme => ({
  blue: {
    backgroundColor: 'blue',
  },

  clientLogo: {
    height: '75%',
    marginLeft: 20,
    maxWidth: 200,
    maxHeight: 50,
  },
});
export const QA_DETAIL_TAB_KEY = 'QA_DETAIL_TAB';
export const tabKeys = {
  profile: 'profile',
  restrictions: 'restrictions',
};

const QaDetailContent = withStyles(styles)(props => {
  const { classes, setPageTitle } = props;
  const { userId } = props.match.params;
 
  
  const {
    state: { permissions: userPermissions, profile: userProfile, restrictions: userRestrictions },
    dispatch,
  } = useContext(QaDetailContext);

  const {
    state: { roles: userRoles,}
  } = useContext(AppContext);

  // const [qaUser, setQaUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [query] = useState(queryString.parse(props.history.location.search));
  const [activeTab, setActiveTab] = useState(0);
  const [allowedTabs, setAllowedTabs] = useState([]);
  const [tabsLoaded, setTabsLoaded] = useState({
    profile: false,
    restrictions: false,
  });

  const updateLoaded = (tabKey, value) => {
    setTabsLoaded(Object.assign({}, tabsLoaded, { [tabKey]: value }));
  };

  const updateActiveTab = key => {
    localStorage.setItem(QA_DETAIL_TAB_KEY, key);
    const activeTabIndex = allowedTabs.findIndex(tab => tab.key === key);
    setActiveTab(activeTabIndex);
  };


  const tabs = userId==="create"?[
    {
      label: 'Profile',
      key: tabKeys.profile,
      permissions: [ADMIN],
      component: (
        <QaDetailProfileTab
          qaUserId={userId}
          loaded={tabsLoaded.profile}
          updateLoaded={val => updateLoaded('profile', val)}
          query={query}
          match={props.match}
          userProfile={userProfile}
          history={props.history}
        />
      ),
    }
  ]:[
    {
      label: 'Profile',
      key: tabKeys.profile,
      permissions: [ADMIN],
      component: (
        <QaDetailProfileTab
          qaUserId={userId}
          loaded={tabsLoaded.profile}
          updateLoaded={val => updateLoaded('profile', val)}
          query={query}
          match={props.match}
          userProfile={userProfile}
          history={props.history}
        />
      ),
    },
    {
      label: 'Skills',
      key: tabKeys.restrictions,
      permissions: [ADMIN],
      component: (
        <QaDetailRestrictionsTab
          qaUserId={userId}
          loaded={tabsLoaded.restrictions}
          updateLoaded={val => updateLoaded('restrictions', val)}
          query={query}
          match={props.match}
          userProfile={userProfile}
          permissions={userPermissions}
          restrictions={userRestrictions}
        />
      ),
    },
  ];

  const checkLastFocusedTabKey = () => {
    const lastFocusedTab = localStorage.getItem(QA_DETAIL_TAB_KEY);

    if (lastFocusedTab) {
      updateActiveTab(lastFocusedTab);
    } else {
      setActiveTab(0); // set to the first tab on the page
    }
  };

  const getQaUserByIdAsync = async qaId => {
    
    try {
      const user = await getQaUserById(qaId);
      setPageTitle(`${user.name}`);
      const restrictions = await getQaUserPermissionsById(qaId);
      const products = await getQaUserPermissions();

      dispatch({ type: 'UPDATE_PROFILE', profile: user });
      dispatch({ type: 'UPDATE_RESTRICTIONS', restrictions: restrictions });
      dispatch({ type: 'SET_PERMISSIONS', permissions: products });
    }
    catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    checkLastFocusedTabKey();
  }, [allowedTabs]);

  useEffect(() => {
      setAllowedTabs(tabs.filter(tab => tab.permissions.some(permission => userRoles.indexOf(permission) >= 0)));
  }, [userRoles]);

  useEffect(() => {
    // getUserById(userId);
    // getQaUserById(userId);
    if(userId != "create"){

      getQaUserByIdAsync(userId);
    }
    return () => {
      localStorage.removeItem(QA_DETAIL_TAB_KEY);
    };
  }, []);


  return (
    <div className={cn('flex-1', 'col-center-start')}>
      {query.referrer && (
        <Button style={{ marginBottom: 10 }} onClick={() => props.history.goBack()}>
          <ChevronLeft />
          Return to {query.referrer}
        </Button>
      )}
      
      <TabBar tabs={allowedTabs} changeTab={updateActiveTab} activeTab={activeTab}/>

      {/* <div style={{ alignSelf:"end", marginRight: 55, marginTop: -45 }}>{qaUser}
      </div> */}

      <div
        className={cn(
          'card',
          'my-10',
          ![tabs.communication].includes(activeTab) && 'flex-1',
          'align-stretch',
          'border-left-green',
        )}
        style={{
          position: 'relative',
          
        }}
      >
        {allowedTabs[activeTab] && allowedTabs[activeTab].component}
      </div>
    </div>
  );
});

export const QaUsersDetail = props => (

  <QaDetailContextProvider>
    {}
    <QaDetailContent {...props}  />
  </QaDetailContextProvider>
);
